import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../../baseContainers/BaseDetailsContainer';
import InputDropdownComponent from '../../../components/inputs/InputDropdownComponent';
import InputTextEditorComponent from '../../../components/inputs/InputTextEditorComponent';
import AppPrefixUtils from '../../../utils/AppPrefixUtils';
import SettingService from '../../../services/SettingService';
import FileUploadService from '../../../services/FileUploadService';
import VoucherService from '../../../services/VoucherService';
import {Dialog, FileUpload} from 'primereact';
import DivContainer from '../../../components/DivContainer';
import YesNoDialog from '../../../components/YesNoDialog';
import VoucherCategoryService from '../../../services/VoucherCategoryService';
import PartnerService from '../../../services/PartnerService';
import VoucherCreateRequest from './VoucherCreateRequest';
import VoucherDetailsResponse from './VoucherDetailsResponse';
import InputCalendarRangeComponent from '../../../components/inputs/InputCalendarRangeComponent';
import moment from 'moment';
import InputNumberComponent from '../../../components/inputs/InputNumberComponent';
import CustomLabel from '../../../components/CustomLabel';
import StringUtils from '../../../utils/StringUtils';
import InputTextComponent from '../../../components/inputs/InputTextComponent';
import EditableDataTableExt from '../../../components/EditableDataTableExt';
import VoucherQRCode from './VoucherQRCode';
import ImageUtils from '../../../utils/ImageUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputLanguageDropdownComponent from '../../../components/inputs/InputLanguageDropdownComponent';
import InputSwitchButtonComponent from '../../../components/inputs/InputSwitchButtonComponent';
import * as XLSX from 'xlsx';

const allowedExtensions = ['csv'];
const allowedExtensionsForImages = ['.png', '.jpg', '.jpeg'];

class VoucherContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new VoucherService());
        this.fileUploadService = new FileUploadService();
        this.voucherCategoryService = new VoucherCategoryService();
        this.partnerService = new PartnerService();
        this.state = {
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            showConfirmRemoveDialog: false,
            showPublishDialog: false,
            renderPrevLogo: true,
            supportedLocales: [],
            showQRCodes: false,
            tempQRCodes: [],
            categories: [],
            partners: [],
            uploadedFile: [],
            selectedFile: undefined,
            element: {
                translations: [],
                visibleToAll: false,
                unlimitedVouchers: false,
            },
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.editorRef = React.createRef();
        this.fileUploadImageRefComponent = React.createRef();
        this.renderLanguages = this.renderLanguages.bind(this);
        this.showQRCodes = this.showQRCodes.bind(this);
        this.removeQRCodes = this.removeQRCodes.bind(this);
        this.getLengthOfSavedQRCodes = this.getLengthOfSavedQRCodes.bind(this);
        this.handlePublish = this.handlePublish.bind(this);
        this.publish = this.publish.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    updateElement(data) {
        this.setState(
            {
                element: VoucherDetailsResponse.copy(this.state.element, data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
    }

    renderCodes() {
        return (
            <EditableDataTableExt
                id='codes'
                name='codes'
                label=''
                showLabel={false}
                columns={[{field: 'code'}]}
                validator={this.validator}
                viewMode={this.props.viewMode}
                onChange={this.handleChange}
                lazy
                paginator
                updateItemElementAfterGetList={() => {}}
                editable={false}
                objectId={this.state.elementId}
                addButtonLabel='Dodaj wartość'
                stateField=''
                getList={this.service.getCodes}
                dataKey='id'
                showDeleteButtonFunctionLabel='Nieaktywny'
            />
        );
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    handlePublish() {
        console.log('publish');
        this.setState({
            showPublishDialog: true,
        });
    }

    publish(type, costam, target) {
        if (target.value) {
            this.scrollToTop();

            this.blockUi();
            if (this._isMounted) {
                this.service
                    .publish(this.state.elementId)
                    .then(() => {
                        const {backUrl} = this.props;
                        this.blockUi();
                        this.persistMessage('success', '', t('voucher.publishSuccess'));
                        // window.location.href = backUrl;
                        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                        this.setState({showPublishDialog: false});
                        this.unblockUi();
                    });
            }
        } else {
            this.setState({showPublishDialog: false});
        }
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }

    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .removeVoucher(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('voucher.successRemove'));
                    // window.location.href = backUrl;
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(t('voucher.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    createOrUpdate() {
        const {element} = this.state;
        const {viewMode} = this.props;
        element.translations = Object.assign({}, element.translations);
        const request = this.prepareElementBeforeRequest(JSON.parse(JSON.stringify(element)));

        // TODO : lepiej moze na backend ale ciul
        if (element.maxPerUser > element.amount) {
            this.showErrorMessage(t('voucher.error.maxPerUserGreaterThanAmount'));
            this.unblockUi();
            return;
        }
        if (viewMode === 'NEW' && this.state.tempQRCodes.length === 0) {
            this.showErrorMessage(t('voucher.error.NoQrCodes'));
            this.unblockUi();
            return;
        }

        if (!request?.imageUuid) {
            this.showErrorMessage(t('voucher.error.imageNotChoosed'));
            this.unblockUi();
            return;
        }

        this.scrollToTop();
        if (this._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }

    initBeforeSetElement() {
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState(
                    {
                        supportedLocales,
                        element:
                            this.props.viewMode === 'NEW'
                                ? new VoucherCreateRequest(this.props.locale, supportedLocales)
                                : new VoucherDetailsResponse(supportedLocales),
                    },
                    () => {
                        let {locale, element} = this.state;
                        this.voucherCategoryService
                            .getCategories(locale)
                            .then((res) => {
                                if (!StringUtils.isBlank(element.category)) {
                                    const category = res.voucherCategories?.find((el) => el.id === element.category.id);
                                    element.category = category;
                                }
                                this.setState({
                                    element,
                                    categories: res.voucherCategories,
                                });
                            })
                            .catch(() => {});
                        this.partnerService
                            .getPartners(locale)
                            .then((res) => {
                                if (!StringUtils.isBlank(element.partner)) {
                                    const partner = res.partners?.find((el) => el.id === element.partner.id);
                                    element.partner = partner;
                                }
                                this.setState({
                                    element,
                                    partners: res.partners,
                                });
                            })
                            .catch(() => {});
                    }
                );
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });
        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }
    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                customRenderFunction: this.renderLanguages,
                rendered: true,
                className: 'float-left',
            },            
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }

    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const editHref = `${editUrl}/${this.state.element?.id}/${locale}`;
        const detailHref = `${detailUrl}/${this.state.element?.id}/${locale}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('voucher.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW',
            },
            {
                label: t('voucher.codesView'),
                onClick: this.showQRCodes.bind(this),
                className: 'float-right',
                iconName: 'mdi-code',
                rendered: viewMode !== 'NEW',
                disabled: StringUtils.isBlank(this.state.element.amount) || this.state.element.amount === 0,
            },
            {
                label: t('global.publish'),
                onClick: this.handlePublish,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered: viewMode === 'VIEW' && this.state.element.status === 'DRAFT',
            },
            {
                label: t('voucher.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: this.props.viewMode === 'VIEW' || this.props.viewMode === 'EDIT',
            },
        ];
    }

    showQRCodes() {
        this.setState({showQRCodes: true});
    }

    getContainerListName() {
        return 'voucher-list-container';
    }
    getAddSucces() {
        return t('voucher.createdMessage');
    }
    getUpdateSucces() {
        return t('voucher.updatedMessage');
    }
    getRemoveSucces() {
        return t('voucher.removedMessage');
    }

    prepareElementBeforeRequest(element) {
        const uploadedFile = this.state.uploadedFile;
        if (uploadedFile?.uuid) {
            element.image = uploadedFile;
            element.imageUuid = uploadedFile?.uuid;
            element.newImage = true;
        } else {
            element.imageUuid = element?.image?.uuid;
            element.newImage = false;
        }
        const tempCodes = this.state?.tempQRCodes;
        if (element.qrCodes) {
            element.qrCodes = element.qrCodes.concat(tempCodes);
        } else {
            element.qrCodes = tempCodes;
        }

        return element;
    }

    renderLanguages() {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                insideTable
                viewMode={'EDIT'}
                onChange={this.handleChange}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    }


    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid'>
                {this.renderView()}
                <YesNoDialog
                    onChange={this.publish}
                    visible={this.state.showPublishDialog}
                    header={t('voucher.publishHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showPublishDialog: false});
                    }}
                >
                    <span>{t('voucher.publishBody')}</span>
                </YesNoDialog>
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('voucher.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    {' '}
                </YesNoDialog>
            </div>
        );
    }

    breadCrumbItems() {
        return [
            {name: t('voucher.listName'), url: '/voucher-list'},
            {name: t('voucher.details'), url: ``},
        ];
    }

    renderDetails() {
        const {elementId, renderPrevLogo, locale} = this.state;
        const uploadOptions = {
            icon: 'none',
            iconOnly: true,
            style: {width: '0px'},
            className: 'invisible',
        };
        return (
            <React.Fragment>
                <div className='col-md-12 col-sm-12'>
                    <div className='row'>
                    <InputTextComponent
                            id={`${locale}-title`}
                            name='title'
                            label={t('voucher.title')}
                            colClass='col-sm-12 col-md-8 col-lg-6 col-xl-4'
                            value={this.state.element?.translations[locale]?.title}
                            validator={this.validator}
                            validators='required|max:38'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            stateField={`element.translations[${locale}]`}
                        />
                        </div>
                        <div class="row">
                         <InputDropdownComponent
                            id='category'
                            name='category'
                            colClass='col-sm-12 col-md-8 col-lg-6 col-xl-4'
                            label={t('voucher.category')}
                            value={this.state.element.category}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            options={this.state.categories}
                            dataKey='id'
                            optionLabel='name'
                            filter
                            filterBy='name'
                        />
                        </div>
                        <div className='row'>
                        <InputCalendarRangeComponent
                            key={`dates`}
                            idFrom={`dateFrom`}
                            nameFrom={`dateFrom`}
                            idTo={`dateTo`}
                            nameTo={`dateTo`}
                            label={t('')}
                            labelFrom={t('voucher.dateFrom')}
                            labelTo={t('voucher.dateTo')}
                            colClass='col-sm-12 col-md-8 col-lg-6 col-xl-4'
                            from={this.state.element.dateFrom}
                            to={this.state.element.dateTo}
                            validator={[this.validator, this.validatorDraft]}
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            showTime
                            showIcon
                            validatorsTo={`required|date|after_or_equal_datetime~${moment(
                                this.state.element.activeFrom ? this.state.element.activeFrom : new Date()
                            )
                                .format('DD-MM-YYYY HH:mm')
                                .toString()}`}
                            placeholderFrom='dd-mm-rrrr GG:MM'
                            placeholderTo='dd-mm-rrrr GG:MM'
                            validateViewMode
                            dateFormatMoment='DD-MM-YYYY HH:mm'
                            validatorsToType='after_or_equal_datetime'
                        />
                        </div>
                        <div class="row">
                            <InputNumberComponent
                            id={`cost`}
                            name='cost'
                            label={t('voucher.cost')}
                            colClass='col-sm-6 col-md-4 col-lg-3 col-xl-2'
                            value={this.state.element?.cost}
                            onChange={this.handleChange}
                            validator={this.validator}
                            viewMode={this.props.viewMode}
                        />
                         <InputNumberComponent
                            id={`maxPerUser`}
                            name='maxPerUser'
                            label={t('voucher.maxPerUser')}
                            colClass='col-sm-6 col-md-4 col-lg-3 col-xl-2'
                            value={this.state.element?.maxPerUser}
                            onChange={this.handleChange}
                            validator={this.validator}
                            viewMode={this.props.viewMode}
                        />
                        </div>
                        <div class="row">
                        <InputNumberComponent
                            id={`amount`}
                            name='amount'
                            label={t('voucher.amount')}
                            colClass='col-sm-6 col-md-4 col-lg-3 col-xl-2'
                            value={this.state.element?.amount}
                            onChange={this.handleChange}
                            validator={this.validator}
                            rendered={this.props.viewMode === 'VIEW'}
                            viewMode={'VIEW'}
                        />
                       
                        <InputNumberComponent
                            id={`amountAllAlreadyBoughtVouchers`}
                            name='amountAllAlreadyBoughtVouchers'
                            label={t('voucher.countOfBoughtsVouchers')}
                            colClass='col-sm-12 col-md-8 col-lg-6 col-xl-4'
                            value={this.state.element?.amountAllAlreadyBoughtVouchers}
                            onChange={this.handleChange}
                            validator={this.validator}
                            rendered={this.props.viewMode === 'VIEW'}
                            viewMode={'VIEW'}
                        />
                       </div>
                       <div class="row">
                        <InputSwitchButtonComponent
                            id={`visibleToAll`}
                            name='visibleToAll'
                            label={t('voucher.visibleToAll')}
                            colClass='col-sm-6 col-md-4 col-lg-3 col-xl-2'
                            value={this.state.element?.visibleToAll}
                            onChange={this.handleChange}                            
                            rendered={this.authService.isUserInAnyRole('ROLE_SUPER_ADMINISTRATOR')}
                            viewMode={this.props.viewMode}
                            labelOnLeft
                        />
                         <InputSwitchButtonComponent
                            id={`unlimitedVouchers`}
                            name='unlimitedVouchers'
                            label={t('voucher.unlimitedVouchers')}
                            colClass='col-sm-6 col-md-4 col-lg-3 col-xl-2'
                            value={this.state.element?.unlimitedVouchers}
                            onChange={this.handleChange}                            
                            rendered={this.authService.isUserInAnyRole('ROLE_SUPER_ADMINISTRATOR')}
                            viewMode={this.props.viewMode}
                            labelOnLeft
                        />
                       </div>
                       <div class="row">
                        
                       
                       
                        {/* <InputDropdownComponent
                            id='partner'
                            name='partner'
                            colClass='col-md-12'
                            label={t('voucher.partners')}
                            value={this.state.element.partner}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            options={this.state.partners}
                            dataKey='id'
                            optionLabel='name'
                            filter
                            filterBy='name'
                        /> */}
                        </div>
                        <div class="row mt-4">

                        {(this.props.viewMode === 'EDIT' || this.props.viewMode === 'NEW') && (
                            <React.Fragment>
                                <CustomLabel
                                    label={
                                        this.props.viewMode === 'VIEW' ? t('voucher.codes') : t('voucher.codes') + t('global.requiredSign')
                                    }
                                />
                                <CustomLabel colClass='col-lg-12' label={t('voucher.csvPolicy')} />
                                <FileUpload
                                    uploadLabel={t('voucher.file.addCSVFile')}
                                    chooseLabel={t('voucher.file.addCSVFile')}
                                    cancelLabel={t('file.cancel')}
                                    multiple={false}
                                    customUpload
                                    className='col-lg-12'
                                    uploadOptions={uploadOptions}
                                    onSelect={this.handleQRCodesChange}
                                    onRemove={this.removeQRCodes}
                                    onClear={this.removeQRCodes}
                                    uploadHandler={this.saveAvatar}
                                    accept='*'
                                />
                            </React.Fragment>
                        )}
                        </div>
                        <div class="row mt-4">
                        <CustomLabel
                            label={this.props.viewMode === 'VIEW' ? t('voucher.image') : t('voucher.image') + t('global.requiredSign')}
                        />
                        <DivContainer rendered={this.props.viewMode !== 'VIEW'}>
                            <FileUpload
                                ref={this.fileUploadImageRefComponent}
                                uploadLabel={t('file.upload')}
                                chooseLabel={t('file.choose')}
                                cancelLabel={t('file.cancel')}
                                multiple={false}
                                customUpload
                                className='col-lg-12'
                                uploadOptions={uploadOptions}
                                onSelect={(e) => this.handleImageUpload(e, allowedExtensionsForImages)}
                                onRemove={this.onClear}
                                onClear={this.onClear}
                                uploadHandler={this.saveAvatar}
                                accept='*'
                                maxFileSize={this.state.imgMaxSizeParameter}
                                invalidFileSizeMessageSummary={t('global.invalidFileSizeSummary')}
                                invalidFileSizeMessageDetail={t('global.invalidFileSizeDetails') + this.state.fileSizeToTranslation}
                            />
                        </DivContainer>

                        <DivContainer className='col-lg-6' rendered={elementId != null && renderPrevLogo}>
                            <img
                                src={`${this.service.getPath()}/image/${
                                    this.state.element?.image?.uuid
                                }?token=${this.authService?.getToken()}`}
                                alt='Idmage icon'
                                className='product-image'
                                style={{height: '150px', width: 'auto'}}
                            />
                        </DivContainer>
                    </div>
                </div>

                <InputTextEditorComponent
                    colClass='col-xl-12 mt-4'
                    id='description'
                    name='description'
                    key={`description-${this.props.viewMode}`}
                    value={this.state.element?.translations[this.state.locale]?.description}
                    label={t('voucher.description')}
                    validator={this.validator}
                    validators='required'
                    rows='5'
                    onChange={this.handleChange}
                    viewMode={'EDIT'}
                    autoResize
                    editorRef={this.editorRef}
                    externalPhotos={true}
                    photos={this.state.element.photos}
                    photoUrl={`${this.service.getPath()}/photo/${elementId}`}
                    photoUploadUrl={`${this.fileUploadService.getPath()}/`}
                    photoLabel='fileName'
                    photoName='uuid'
                    handleError={this.onUploladError}
                    restrictExt={false}
                    token={this.authService.getToken()}
                    photoVarName='photos'
                    stateField={`element.translations[${this.state.locale}]`}
                    disabled={this.props.viewMode === 'VIEW'}
                />
                {this.state.showQRCodes ? (
                    <Dialog
                        onChange={(type, x, target) => {}}
                        visible={this.state.showQRCodes}
                        header={t('voucher.QrCodes')}
                        name='visible'
                        onHide={() => {
                            this.setState({showQRCodes: false});
                        }}
                        yesButtonClassName='red-button'
                    >
                        {this.renderCodes()}
                    </Dialog>
                ) : null}
            </React.Fragment>
        );
    }

    uploadHandler = async (extension) => {
        this.blockUi();
        const selectedFile = this.state.selectedFile;
        const formData = new FormData();
        formData.append('file', selectedFile);
        this.fileUploadService
            .uploadAttachemnt(formData, extension)
            .then((uploadedFile) => {
                this.setState({uploadedFile});
                this.unblockUi();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                //czyscimy niepoprawny plik
                var clearUploadedIncorrectFile = setInterval(function () {
                    let btn = document.getElementsByClassName('p-button p-component')[8];
                    btn.click();
                    clearInterval(clearUploadedIncorrectFile);
                }, 10);
                //
                this.unblockUi();
            });
    };

    removeQRCodes = () => {
        const tempLength = StringUtils.isBlank(this.state?.tempQRCodes?.length) ? 0 : this.state?.tempQRCodes?.length;
        this.setState((prevState) => ({
            tempQRCodes: [],
            element: {
                ...prevState.element,
                amount: this.getLengthOfSavedQRCodes() - tempLength,
            },
        }));
    };

    getLengthOfSavedQRCodes() {
        const amount = StringUtils.isBlank(this.state?.element?.amount) ? 0 : this.state?.element?.amount;
        return amount;
    }

    handleImageUpload = (e, ext) => {
        if (ImageUtils.notValidImageFormat(e.files[0])) {
            this.showErrorMessage(t('image.notValidImageType'));
            this.fileUploadImageRefComponent.current.clear();
            this.unblockUi();
            return;
        }
        this.setState(
            {
                selectedFile: e.files[0],
                renderPrevLogo: false,
            },
            () => {
                this.uploadHandler(ext);
            }
        );
    };

    handleQRCodesChange = (e) => {
        if (e.files[0]) {
            const inputFile = e.files[0];
            const fileExtension = inputFile?.type.split('/')[1];
            if (!allowedExtensions.includes(fileExtension)) {
                this.showErrorMessage(t('voucher.error.NotValidExtension'));
                var clearUploadedIncorrectFile = setInterval(function () {
                    let btn = document.getElementsByClassName('p-button p-component')[5];
                    btn.click();
                    clearInterval(clearUploadedIncorrectFile);
                }, 10);
            } else {
                const reader = new FileReader();
                reader.onload = async ({target}) => {
                    const workbook = XLSX.read(target.result, {type: 'string'});
                    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                    let parsedData = XLSX.utils
                        .sheet_to_json(firstSheet, {header: 1, raw: false})
                        .filter((row) => row?.some((value) => `${value ?? ''}`.trim() !== ''));
                    //parsedData.pop();
                    console.log(parsedData);
                    const tempQRCodes = parsedData.map((el) => VoucherQRCode.copy(el[0]));
                    this.setState((prevState) => ({
                        tempQRCodes,
                        element: {
                            ...prevState.element,
                            amount: this.getLengthOfSavedQRCodes() + parsedData.length,
                        },
                    }));
                };
                reader.readAsText(inputFile);
            }
        }
    };

    onClear = () => {
        this.setState({
            selectedFile: undefined,
            uploadedFile: undefined,
            renderPrevLogo: true,
        });
    };
}

VoucherContainer.defaultProps = {
    backUrl: '/voucher-list',
    editUrl: '/voucher/edit',
    detailUrl: '/voucher/details',
    lazy: true,
};

VoucherContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
    detailUrl: PropTypes.string,
};

export default withRouter(withTranslation()(VoucherContainer));
